import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CallHistoryService } from '../../call-history.service';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { getCallHistoryPageSelector } from '../../call-history.reducer';
import { Store } from '@ngrx/store';
import { IState } from '../../../shared/models/state';
import { CallHistorySearchParams, CallMsisdns } from '../../call-history-params.interface';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'cc-call-numbers-filter',
  templateUrl: './call-numbers-filter.component.html',
  styleUrls: ['./call-numbers-filter.component.scss']
})
export class CallNumbersFilterComponent implements OnInit {
  @Input() msisdns: CallMsisdns[];
  @Input() allNumbersSelected: boolean;
  @Output() toggleSelectAll = new EventEmitter();
  public indeterminate: boolean;
  public filters: CallHistorySearchParams = {};
  @ViewChild('numbersSelector') numbersSelector: MatSelect;
  public selectedMsisdnsForm = new FormControl();
  public displayedNumber: CallMsisdns;

  constructor(private callHistoryService: CallHistoryService, private store: Store<IState>) {}

  ngOnInit() {
    this.store.select(getCallHistoryPageSelector).subscribe(params => {
      this.filters = params;
      const selectedNumbers =
        this.msisdns && this.filters.channelsMsisdnsIds
          ? this.msisdns.filter(item => {
              return this.filters.channelsMsisdnsIds.includes(item.id);
            })
          : [];
      const ids = selectedNumbers.map(i => i.id);
      this.selectedMsisdnsForm.setValue(ids);
      this.setCheckboxAll(this.msisdns, selectedNumbers);
      this.updateDisplayValue(ids);
    });
    this.setCheckboxAll(this.msisdns, []);
    this.liveUpdateSelectedValue();
  }

  addFilter(type, value) {
    this.callHistoryService.addFilter(type, value, this.callHistoryService.getPagerIndexReset(this.filters.pager));
  }

  setCheckboxAll(itemsList, requestedProjectList) {
    this.allNumbersSelected = this.callHistoryService.setCheckboxAll(itemsList, requestedProjectList).allSelected;
    this.indeterminate = this.callHistoryService.setCheckboxAll(itemsList, requestedProjectList).indeterminate;
  }

  toggleAllNumbersSelect() {
    this.toggleSelectAll.next();
    if (this.allNumbersSelected) {
      this.numbersSelector.options.forEach((item: MatOption) => {
        item.select();
      });
    } else {
      this.numbersSelector.options.forEach((item: MatOption) => item.deselect());
    }
  }

  // avoid calculating displayed label on every re-render
  private liveUpdateSelectedValue() {
    this.selectedMsisdnsForm.valueChanges.subscribe((selectedIds: number[]) => {
      this.updateDisplayValue(selectedIds);
    });
  }

  private updateDisplayValue(selectedIds: number[]) {
    if (!selectedIds || !selectedIds.length) {
      this.displayedNumber = null;
      return;
    }
    this.displayedNumber = this.msisdns.find(({ id }) => id === selectedIds[0]);
  }
}
